export default __webpack_public_path__ + "static/media/Boots of Pandemonium.3bbc3df7.jpg";